import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { LinkOrDiv } from '../../front/components/events/helpers'
import { fetchNews } from './fetch-news'

import {
    forFeature,
    i18n,
} from '../../validator'
import Loader from '../../front/components/shared/loader'
import SnIcon from '../../front/components/shared/sn-icon'

@forFeature('SHOW_ACTUALITY')
@i18n()
class LandingNews extends Component {
    static propTypes = {
        isWebView: PropTypes.bool,
    }

    constructor() {
        super()

        this.state = {
            show: 0,
        }

        this.newsInterval = null
    }

    componentDidMount = () => {
        fetchNews(false, 5)
            .then(() => {
                if (this.newsInterval) {
                    clearInterval(this.newsInterval)
                }

                this.newsInterval = setInterval(() => {
                    if ((this.state.show + 1) >= this.props.news.ids.length) {
                        this.setState({ show: 0 })
                    } else {
                        this.setState({ show: this.state.show + 1 })
                    }
                }, 5000)
            })
    }

    renderNews = () => {
        const {
            news,
            busy,
        } = this.props

        if (busy) {
            return <Loader width={25} />
        }

        if (!news || news.ids.length === 0) {
            return null
        }

        return news.ids.map(id => (
            <LinkOrDiv
                key={id}
                href={`/aktuality/${news.data[id].slug}`}
                reactLink={!this.context.isWebView}
                className="Header-news-content"
                scrollToTop={false}
            >
                <span dangerouslySetInnerHTML={{ __html: news.data[id].name }} />
                <SnIcon className="sn-arrow sn-sm sn-rotate-180" />
            </LinkOrDiv>)
        )
    }

    render() {
        const newsRenders = this.renderNews()
        const renderActuality = newsRenders && newsRenders.length > 0 ? newsRenders[this.state.show] : newsRenders
        const { t } = this.props

        return (
            <div className="Header-news">
                <div className="Header-news-in">
                    <LinkOrDiv reactLink={!this.context.isWebView} href="/aktuality" className="Header-news-button">{t('news')}</LinkOrDiv>
                    {renderActuality}
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    news: state.app.news,
    busy: state.ui.busySections.news,
}))(LandingNews)
